import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { MQService, MQMessage } from '../../services/mq.service';
import { MQComponent } from '../../components/MQComponent';
import { ConfigService } from '../../services/config.service';

interface LoaderMessage extends MQMessage {
    text: string,
    html?: string,
    delay?: number
}

interface State {
    display: boolean, error: boolean, msg: LoaderMessage
}

@Component({
    selector: 'app-loader',
    templateUrl: './loaderlayer.component.html',
    styleUrls: ['./loaderlayer.component.scss']
})

export class LoaderLayerComponent extends MQComponent implements OnInit {
    @Input() debug: boolean;
    private image = '';
    private state: State;
    private stateQueue: State[];

    private interval: any;
    private timer: any;

    constructor(protected mq: MQService, private gv: ConfigService) {
        super(mq);
        this.state = {
            display: false,
            error: false,
            msg: {
                text: ''
            }
        }
        this.stateQueue = [];
    }

    ngOnInit() {
        this.image = this.assets('/assets/images/loader.gif')
        super.listenOn('loader.show', (msg: LoaderMessage) => {
            this.stateQueue.push({
                display: true,
                error: false,
                msg: msg
            });
            this.startInterval();
        })
        super.listenOn('loader.alert', (msg: LoaderMessage) => {
          if (this.debug) {
            this.stateQueue.push({
                display: true,
                error: true,
                msg: msg
            });
          }
          this.startInterval();
        })
        super.listenOn('loader.debug', (msg: LoaderMessage) => {
          if (this.debug) {
            this.stateQueue.push({
                display: true,
                error: true,
                msg: msg
            });
          }
            // this.startInterval();
        })
        super.listenOn('loader.close', (msg: LoaderMessage) => {
            this.stateQueue.push({
                display: false,
                error: false,
                msg: msg
            });
            this.startInterval();
        });
    }

    private startInterval() {
        if (!this.interval) {
            this.interval = setInterval(() => {
                if (this.stateQueue.length > 0) {
                  this.state = this.stateQueue.shift();
                } else {
                  this.startTimer();
                }
              }, 500);
        }
    }
    private startTimer() {
        if (!this.timer) {
            this.timer = setTimeout(() => {
              if (this.stateQueue.length === 0 && !this.state.display) {
                if (this.interval) {
                  clearInterval(this.interval);
                  this.interval = null;
                }
                this.timer = null;
              }
            }, 6000);
          }
    }

    onClose(): void {
        this.state =  {
            display: false,
            error: false,
            msg: {
                text: ''
            }
        }
        if (this.interval) {
            clearInterval(this.interval);
            this.interval = null;
          }

        if (!this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
        }
    }

    private assets(suffix: string = ''): string {
        const prefix = this.gv.getString('assets');
        return `${prefix}${suffix}`;
    }
}
